import React from 'react';
import { dateTimeInNwt } from '../../../utils/nwtDate';

/** The NWT time an aircraft modal's snapshot was taken (#866); nothing when unknown. */
export const AffAsOf: React.FC<{ asOf?: number }> = ({ asOf }) =>
  asOf == null ? null : (
    <p className="aff-as-of">As of {dateTimeInNwt(asOf)} NWT. Reopen the aircraft for its latest position.</p>
  );
